module.exports = __webpack_public_path__ + "img/tombstone.93e2b369.svg";